import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div  className="text-white  font-sans-serif poppins">
      <div className="pb-10 text-white  font-sans-serif poppins">
        <p className="leading-8 text-opacity-60 font-normal my-3">
          01/ General Rules Protection Regulations (GDPR)
        </p>
        <p className="leading-8 my-6">
        Your data is managed by us as a data controller. Depending on the personal information we collect and the context in which we acquire it, the legal basis for collecting and using your personal information, as stated in this Privacy Policy, varies at PYREXIA 2025, AIIMS Rishikesh: 
        </p>
        <ul className="list-disc list-inside">
          <li className="leading-8 my-3">You must fulfill the terms of a contract with PYREXIA 2025, AIIMS Rishikesh. </li>
          <li className="leading-8 my-3">You have provided explicit consent to PYREXIA 2025, AIIMS Rishikesh. </li>
          <li className="leading-8 my-3">PYREXIA 2025, AIIMS Rishikesh has a legitimate interest in processing your personal information. </li>
          <li className="leading-8 my-3">PYREXIA 2025, AIIMS Rishikesh must comply with legal obligations</li>
          <li className="leading-8 my-3">
          Your personal information will only be retained for as long as is necessary to meet the purposes outlined in this privacy statement. We will retain and use your information as required to comply with legal obligations, resolve disputes, and enforce our policies.
          </li>
        </ul>
        <p className="leading-8 my-6">
        If you wish to know what personal information we hold about you or if you want it deleted from our systems, please contact us.
        </p>
        <p>You may exercise the following data protection rights under certain conditions: </p>
        <ul className="list-disc list-inside">
          <li className="leading-8 my-3">The right to access, update, or delete the data we hold about you. </li>
          <li className="leading-8 my-3">The right to rectification. </li>
          <li className="leading-8 my-3">The right to withdraw consent. </li>
        </ul>
      </div>

      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">02/ Log Files</p>
        <p className="leading-8 my-6">
        PYREXIA 2025, AIIMS Rishikesh, follows a standard procedure for using log files. These files log visitors when they visit websites. Hosting companies do this as part of their analytics services. Information collected by log files includes internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamps, referring/exit pages, and possibly the number of clicks. None of this information is linked to any personally identifiable information. The purpose of this information is to analyze trends, administer the website, track user movements on the site, and gather demographic information. Non-personally identifiable information is collected to improve the user experience on our website. 
        </p>
      </div>

      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">03/ Policy Concerning Third Parties</p>
        <p className="leading-8 my-6">
          Third-party ad servers or ad networks may use technologies like cookies, JavaScript, or Web Beacons in the advertisements and links that appear on the PYREXIA 2025 website. These technologies are sent directly to users' browsers, and your IP address is automatically received. These tools help measure the effectiveness of advertising campaigns and tailor content for you. 
        </p>
        <p className="leading-8 my-6">
          PYREXIA 2025, AIIMS Rishikesh, has no access to or control over these cookies used by third-party advertisers. 
        </p>
        <p className="leading-8 my-6">
          Our Privacy Policy does not apply to other advertisers or websites. We recommend reviewing the respective Privacy Policies of these third-party ad servers for more detailed information, including instructions on how to opt out of certain practices. 
        </p>
        <p className="leading-8 my-6">
        You can disable cookies through your individual browser options. Detailed information about cookie management for specific browsers can be found on the browsers' respective websites. 
        </p>
        
      </div>

      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">04/ Cookies and Web Beacons</p>
        <p className="leading-8 my-6">
        Like most websites, the PYREXIA 2025 website uses cookies. These cookies store information such as visitors' preferences and the pages on the website they visit. This information helps us optimize users' experience by tailoring web page content based on visitors' browser types and other information. 
        </p>
      </div>

      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">05/ Parental Guidelines</p>
        <p className="leading-8 my-6">
        Protecting children while they use the internet is a priority. We encourage parents and guardians to observe, participate in, and guide their children's online activity. PYREXIA 2025 does not knowingly collect any personal information from children under the age of 12. If you believe your child has provided such information on our website, we strongly urge you to contact us immediately, and we will make our best effort to promptly remove such information from our records.
        </p>
      </div>

      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">06/ Online Privacy Policy</p>
        <p className="leading-8 my-6">
        This Privacy Policy applies solely to the online activities of PYREXIA 2025 (PYREXIA 5.0) and is valid for visitors to our website regarding the information they share and/or collect in PYREXIA 2025, AIIMS Rishikesh. This policy does not apply to any information collected offline or via channels other than this website. 
        </p>
      </div>

      <div className="pb-10">
        <p className="leading-8 text-opacity-60 font-normal my-3">07/ Consent </p>
        <p className="leading-8 my-6">
        By using our website, you hereby consent to our Privacy Policy and agree to its terms. 
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;